import { css } from '@/styled-system/css';

export const headerNavButtonStyles = css.raw({
  textAlign: 'center',
  _hover: { color: 'text.accent.brand.hero', fontWeight: '600' },
});
